import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";
import { fieldValueToString } from "../../../utils/react_hook_form_input_utils";

/**
 * FormSelectInputOption
 */

export type FormSelectInputOption = { id: number, label: string } | { id: string, label: string };

/**
 * FormSelectInput
 */

type Props<T extends {},> = {
  name: keyof T,
  label: string,
  required?: boolean,
  readOnly?: boolean,
  options: FormSelectInputOption[],
  initialOptionId?: number | string,
  initialOptionLabel?: string,
  showSelectionLabel?: boolean,
  reactHookForm: UseFormReturn<T>,
};

export const FormSelectInput = <T extends {},>({
  name,
  label,
  required,
  readOnly,
  options,
  initialOptionId = '',
  initialOptionLabel = 'Selecionar',
  showSelectionLabel = true,
  reactHookForm,
}: Props<T>) => {
  return (
    <Controller
      name={name as any}
      control={reactHookForm.control}
      render={({ field, formState }) => {
        let helperText = null;

        if (name in formState.errors) {
          const error = formState.errors[name] as any;
          if (typeof error.message === 'string') {
            helperText = error.message;
          }
        }

        return (
          <FormControl size="small" fullWidth={true} required={required}>
            <InputLabel
              id={`select-${name as string}`}
              size="small"
              error={helperText !== null}
              required={required}>
              {label}
            </InputLabel>

            <Select
              size="small"
              labelId={`select-${name as string}`}
              label={label}
              required={required}
              inputProps={{ readOnly: readOnly }}
              disabled={formState.disabled}
              value={fieldValueToString(field.value) ?? ''}
              onChange={field.onChange}>
              {showSelectionLabel && <MenuItem value={initialOptionId}>{initialOptionLabel}</MenuItem>}
              {options.map(x => <MenuItem key={x.id} value={x.id}>{x.label}</MenuItem>)}
            </Select>

            <FormHelperText id={`select-${name as string}`} error={true}>
              {helperText}
            </FormHelperText>
          </FormControl>
        );
      }} />
  );
}